import { render, staticRenderFns } from "./RevisionHistoryDialog.vue?vue&type=template&id=77182eb0&"
import script from "./RevisionHistoryDialog.vue?vue&type=script&lang=ts&"
export * from "./RevisionHistoryDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports